import { Button, Result } from "antd";
import React from "react";
import { Link } from "react-router-dom";

const Forbidden403NotBL = () => {
  return (
    <Result
      status="403"
      title="403"
      subTitle="Beklager, du må være aktivt medlem i Bindeleddet for å kunne besøke denne siden"
      extra={
        <Link to="/">
          <Button type="primary">Tilbake hjem</Button>
        </Link>
      }
    />
  );
};

export default Forbidden403NotBL;
